// extracted by mini-css-extract-plugin
export default {"lpBody":"Layout_lpBody__sJAQd"};